export type Config = {
    readonly botId: string;
    readonly featureFlags: string[];
    readonly groundTeamRatingsConfig: GroundTeamRatingsConfig;
};

export interface GroundTeamRatingsConfig {
    maxQueryPeriodDays: number;
}

export const FeatureFlags = {
    allowFailedConnectionSimulation: 'AllowFailedConnectionSimulation',
    conversationsSummarisation: 'ConversationsSummarisation',
} as const;
